export default __webpack_public_path__ + "static/media/Alaska-Airlines-Logo.d2933cd7.png";